/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface LoginRequestDto {
  username: string;
  password: string;
  subSystem: LoginRequestDto.SubSystemEnum;
  deviceId: string;
  firebaseToken: string;
  preferLanguage: LoginRequestDto.PreferLanguageEnum;
}
// tslint:disable-next-line:no-namespace
export namespace LoginRequestDto {
  export type SubSystemEnum = 'enterprise_web_admin' | 'enterprise_tablet_app' | 'member_app';
  export const SubSystemEnum = {
      EnterpriseWebAdmin: 'enterprise_web_admin' as SubSystemEnum,
      EnterpriseTabletApp: 'enterprise_tablet_app' as SubSystemEnum,
      MemberApp: 'member_app' as SubSystemEnum,
  };
  export type PreferLanguageEnum = 'th' | 'en';
  export const PreferLanguageEnum = {
      Th: 'th' as PreferLanguageEnum,
      En: 'en' as PreferLanguageEnum,
  };
}
